import React, { useRef } from 'react'
import { BlockComponentProps } from '../../../../doclets/types'
import { useDocletImage } from '../../../../doclets/blocks/image/ImageBlock'
import { ImageTextRow } from '../../../../doclets/blocks/imageText/ImageTextBlock'
import EditableImage from './EditableImage'
import { DocletTextEditor } from './TextBlockEditor'

/**
 * Builder editor for Image + text: the Image block's picture editing and the
 * Text block's editor, laid out as on the page. Side, size and alt text are
 * in the block settings sidebar.
 */
const ImageTextBlockEditor = ({
  block,
  onChange,
  onFocus,
  selected = false
}: BlockComponentProps<'imageText'>) => {
  const image = useDocletImage(block)
  // The upload finishes later: merge into the props as they are then (the
  // text may have been edited meanwhile)
  const latest = useRef({ props: block.props, onChange })
  latest.current = { props: block.props, onChange }

  // The formatting row goes above the image and text together, so they stay
  // level when it appears on selection, lined up with the text it formats
  return (
    <DocletTextEditor
      body={block.props.body}
      onBodyChange={body =>
        latest.current.onChange?.({ ...latest.current.props, body })
      }
      onFocus={onFocus}
      selected={selected}
      layout={({ formatBar, text }) => (
        <ImageTextRow
          block={block}
          image={image}
          imageNode={
            <EditableImage
              block={block}
              onUploaded={uploaded =>
                latest.current.onChange?.({
                  ...latest.current.props,
                  ...uploaded
                })
              }
              onFocus={onFocus}
              selected={selected}
            />
          }
          textNode={text}
          aboveText={formatBar}
        />
      )}
    />
  )
}

export default ImageTextBlockEditor
